import {createSelector} from 'reselect';

import {ApplicationStoreType} from 'reducers';
import {PRODUCT_TYPES} from 'constants/product';

import {
    CheckoutContactsItemV2Type,
    CheckoutGlassesItemV2Type,
    OrderReviewType,
} from 'reducers/checkout/orderReview/orderReviewType';
/**
 * Returns list of order items in checkout review
 * @param {ApplicationStoreType} store - Current order review
 * @returns {OrderReviewType} - List of order items
 */
export const getOrderReview = (store: ApplicationStoreType): OrderReviewType => store.orderReview;

/**
 * It implements get order review items for checkout
 * @param {OrderReviewType} orderReview - from store
 * @returns {Array<CheckoutQuoteItemType>} - items
 */
export const getOrderReviewItems = createSelector(
    getOrderReview,
    (
        orderReview: OrderReviewType,
    ): Array<CheckoutGlassesItemV2Type | CheckoutContactsItemV2Type> => {
        return orderReview.items.items;
    },
);
/**
 * It counts quantity of order items
 * @param {Array<CheckoutQuoteItemType>} orderReviewItems - order review items
 * @returns number - number of items in checkout
 */
export const getOrderReviewCounts = createSelector(
    getOrderReviewItems,
    (orderReviewItems: Array<CheckoutGlassesItemV2Type | CheckoutContactsItemV2Type>): number =>
        orderReviewItems.reduce(
            (sum: number, item: CheckoutGlassesItemV2Type | CheckoutContactsItemV2Type) =>
                sum + item.qty,
            0,
        ),
);

/**
 * It counts quantity of only active order items
 * @param {Array<CheckoutQuoteItemType>} orderReviewItems - order review items
 * @returns number - number of items in checkout
 */
export const getOrderReviewActiveItemsCount = createSelector(
    getOrderReviewItems,
    (orderReviewItems: Array<CheckoutGlassesItemV2Type | CheckoutContactsItemV2Type>): number =>
        orderReviewItems.reduce(
            (sum: number, item: CheckoutGlassesItemV2Type | CheckoutContactsItemV2Type) =>
                item.active ? sum + item.qty : sum,
            0,
        ),
);

/**
 * Is any contacts product in order?
 */
export const isContactLensesInOrder = createSelector(getOrderReviewItems, items =>
    items.some(item => item.product.type === PRODUCT_TYPES.CONTACT_LENSES),
);
/**
 * It defines if order review status is fulfilled
 * @param {OrderReviewType} orderReview - from store
 * @returns {boolean} - true if order review status is fulfilled
 */
export const isOrderReviewFulfilled = createSelector(
    getOrderReview,
    ({status}: OrderReviewType): boolean => status === 'fulfilled',
);
